export default "__VITE_ASSET__5WM7yXdb__"